import React from "react";
import Titleofsection from "./titleofsection";
import Project from "./project";
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// images
import img2 from "../img/house2.jpg";
import img3 from "../img/house3.jpeg";
import img4 from "../img/house4.jpg";
import img5 from "../img/house5.jpg";
import img6 from "../img/house6.jpg";
import img7 from "../img/house7.jpeg";
import PagetransitionRight from "../pagetrantionRight";

export default function Projectsection() {
  return (
    <div name="Projects">
      <div className="container">
        <PagetransitionRight>
          <Titleofsection
            title={"Projects"}
            spantitle={"Completed"}
            descreption={
              "Crafting Spaces, Building Legacies-Explore Our Portfolio"
            }
          />

          <div className="projects">
            <Swiper
              slidesPerView={4}
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              loop={true}
              modules={[Pagination, Autoplay]}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                },
                500: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 4,
                },
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <Project
                  img={img2}
                  name={"Vista Verde"}
                  information={"$2,50,000 | California"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Project
                  img={img3}
                  name={"Serenity Suite"}
                  information={" $2,50,000 Chicago"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Project
                  img={img4}
                  name={"Central Square"}
                  information={"$2,50,000 | Los Angeles"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Project
                  img={img5}
                  name={"Skyline Haven"}
                  information={"$2,50,000 | San Francisco"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Project
                  img={img6}
                  name={"Vista Verde"}
                  information={"$2,50,000 | California"}
                />
              </SwiperSlide>
              <SwiperSlide>
                <Project
                  img={img7}
                  name={"Central Square"}
                  information={"$2,50,000 | Los Angeles"}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </PagetransitionRight>
      </div>
    </div>
  );
}
